// Mirrors the legacy watchEditUser localStorage seeding — only keeps the two
// flags that still gate live popups (the rest have date gates that expired or
// no readers left). See TEMP-17004 audit.
export const suppressPostSignupPopups = (userId: string): void => {
  localStorage.setItem(`isNewToYouTabNew-${userId}`, 'false');
  localStorage.setItem(`candidateSortAnnouncement-${userId}`, 'false');
};
